import Payment from '@material-ui/icons/Payment';

import List from './List2';

export default {
  list: List,
  icon: Payment,
};
